<template>
  <div class="doclib-card" @click="goToKbaseFile">
      <div class="show" v-show="[3,1].includes(newCardData.display_type)">公开</div>
      <div class="simple-kbase-base">
        <div class="simple-kbase-image">
          <img :src="iconImage" />
        </div>
        <p class="simple-kbase-name">
          {{newCardData.name}}

          <i
            :class="['iconfont', !!newCardData.is_collected ? 'icon-star' : 'icon-unstar']"
            @click="(e) => updateStatus(e)"
          />
        </p>
      </div>
      <p class="simple-kbase-des">
        {{newCardData.content}}
      </p>
  </div>
</template>
<script>
import ajax from '@/utils/ajax'
import { HOMEPAGE_COLLECT } from '@/config/api'
import { toast } from '@/utils/common'
import config from '@/config'
import { CommonMixin } from '../file/commonMixin'
export default {
  name: 'DoclibCard',
  props: {
    cardData: {
      type: Object,
      default: () => ({})
    },
    userInfo: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      newCardData: {}
    }
  },
  mixins: [CommonMixin],
  computed: {
    iconImage () {
      if (this.isImageUrl(this.newCardData.pic_url) || this.isImageUrl(this.newCardData.pic_file_id)) {
        return this.newCardData.pic_url || this.newCardData.pic_file_id
      } else {
        return require('../images/' + (this.newCardData.pic_url || this.newCardData.pic_file_id) + '.png')
      }
    }
  },
  created () {
    this.newCardData = Object.assign({}, this.cardData)
  },
  mounted () {

  },
  methods: {
    goToKbaseFile () {
      // let isSuperAdmin = this.userInfo.roles && this.userInfo.roles.includes('ROLE_SUPER_ADMIN')
      // let { display_type, is_member } = this.newCardData

      // if (!isSuperAdmin && (display_type === 2 || display_type === 1) && !is_member) {
      //   toast('当前知识库仅允许该知识库成员查看，请联系管理员。')
      //   return
      // }

      this.appFn({
        action: 'route',
        data: `${window.location.origin}/h5/doclib/files/${this.newCardData.library_id}`
      }, () => {
        this.$router.push({ path: `/doclib/files/${this.newCardData.library_id}` })
      })
    },
    updateStatus (e) {
      e.stopPropagation()
      let is_collected = this.newCardData.is_collected
      let msg = is_collected ? '取消收藏' : '收藏'
      ajax({
        url: HOMEPAGE_COLLECT,
        baseUrl: config.doclib_application_url,
        noPrefix: true,
        data: {
          doc_id: this.newCardData.library_id,
          status: this.newCardData.is_collected ? 0 : 1,
          doc_type: 'library',
          library_id: this.newCardData.library_id
        }
      }).then(res => {
        if (res.success) {
          this.newCardData.is_collected = !is_collected
          toast(msg + '成功!')
        } else {
          toast(msg + '失败!')
        }
      })
    },
    isImageUrl (url) {
      const regex = /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)/
      return regex.test(url)
    }
  }
}
</script>
<style lang="postcss" scoped>
  .doclib-card {
    width: 100%;
    display: flex;
    padding: 24px 24px 20px 24px;
    flex-direction: column;
    align-items: flex-start;
    box-sizing: border-box;
    border-radius: 8px;
    background: #FFF;
    margin-top: 12px;
    position: relative;

    &:first-child {
      margin-top: 0;
    }

    & .simple-kbase-base {
      display: flex;
      align-items: center;
      width: 100%;

      & .simple-kbase-image {
        width: 24px;
        height: 24px;
        margin-right: 12px;

        & img {
          width: 100%;
          height: 100%;
        }
      }

      & .simple-kbase-name {
        display: flex;
        width: 100%;
        justify-content: space-between;
        color: #1B2532;
        font-family: "PingFang SC";
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 24px;

        & .icon-star {
          color: #FFCB01;
        }
      }
    }

    & .simple-kbase-des {
      width: 100%;
      color: #626F84;
      font-feature-settings: 'liga' off, 'clig' off;
      font-family: "PingFang SC";
      font-size: 14px;
      font-style: normal;
      font-weight: 300;
      line-height: 22px;
      margin-top: 12px;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
    }

    & .show {
      display: flex;
      height: 16px;
      padding: 10px 8px;
      justify-content: center;
      align-items: center;
      border-radius: 8px 0px;
      background: linear-gradient(90deg, #DD39F8 0%, #8E54E9 70.31%);
      position: absolute;
      top: 0;
      left: 0;
      color: #FFF;
      font-family: "PingFang SC";
      font-size: 10px;
      font-style: normal;
      font-weight: 600;
      box-sizing: border-box;
    }
  }
</style>
